export default __webpack_public_path__ + "static/works-1-1-42c10a3350cedd8c183b808898a08eab.jpg";